const home = {
  range: {
    eyebrow: 'Our Products',
    heading: 'Explore Our Range',
    // Same order as the cards in Home.js (products, grade guide, true cinnamon)
    features: [
      {
        title: 'Premium Grades',
        description: 'Continental and Hamburg grades, quillings, off cuts, cinnamon oil, pepper and betel.',
        linkText: 'View Products',
      },
      {
        title: 'Choosing a Grade',
        description: 'Which grade suits retail, drinks, baking or manufacturing — plus storage and cooking tips.',
        linkText: 'Find Your Grade',
      },
      {
        title: 'True Cinnamon',
        description: 'Heritage, craft, and how to tell Ceylon from Cassia—the rich story behind real cinnamon.',
        linkText: 'Explore True Cinnamon',
      },
    ],
  },

  about: {
    eyebrow: 'About Spice Yield',
    title: 'Bringing the Natural Goodness of Authentic Spice Yields to the World',
    intro: 'We are a family-owned operation with deep roots in Sri Lanka\'s southern coastal belt, where we tend our own spice estates. Our commitment to quality, sustainability, and traditional craftsmanship has made us a trusted name in over 50 countries worldwide.',
    // Split around the Latin name, which is set in italics
    knownAs: {
      before: 'Known as "true cinnamon" or ',
      after: ', our Ceylon cinnamon is celebrated for its delicate, sweet flavor and incomparable aroma that has captivated civilizations for over four millennia.',
    },
    link: 'Learn Our Story',
    // Shown with the "30+" badge on the estate photo
    badgeText: 'Years of Experience',
  },

  why: {
    eyebrow: 'Why Spice Yield',
    title: 'Excellence in Every Strand',
    subtitle: 'Our adherence to international quality standards and passion for authentic flavors have made us a trusted global brand.',
    // Same order as the icons in Home.js
    cards: [
      { title: 'Quality Assured', text: 'Every batch tested and certified to meet the highest international standards.' },
      { title: 'Global Reach', text: 'Trusted partner to businesses in over 50 countries across 6 continents.' },
      { title: 'Vertically Integrated', text: 'From our own estates to your doorstep—complete control over quality.' },
      { title: 'Sustainably Sourced', text: 'Committed to ethical practices that protect people and the planet.' },
    ],
  },

  stats: {
    eyebrow: 'Our Impact',
    title: 'Spice Yield at a Glance',
    items: [
      { number: '30+', label: 'Years of Excellence', suffix: 'Since 1994' },
      { number: '50+', label: 'Countries Worldwide', suffix: 'Global Reach' },
      { number: '100%', label: 'Quality Assured', suffix: 'Every batch tested' },
      { number: '7', label: 'Cinnamon Grades', suffix: 'C5 to H3' },
    ],
  },

  cta: {
    eyebrow: 'Get Started',
    title: 'Ready to Source Authentic Ceylon Cinnamon?',
    text: 'Whether you\'re a retailer, manufacturer, or distributor, we\'re here to provide premium quality spices directly from Sri Lanka.',
    primary: 'Request a Quote',
    secondary: 'View Products',
    statText: 'Countries Trust Us',
  },
};

export default home;
